const defaultState = {
  isFetched: false,
  orders: {
    contract: {},
    stbs: [],
    cards: [],
    cardReaders: []
  },
  noProduct: true
};

const defaultOrders = {
  devices: [],
  viihdeAppSubscription: {},
  cardLinks: []
};

export default function omaviihde(state = defaultState, action) {
  switch (action.type) {
    case 'OMAVIIHDE_FETCHING':
      return defaultState;

    case 'OMAVIIHDE_CONTRACT':
      return action.product ? { ...action.product, isFetched: true } : defaultState;

    case 'OMAVIIHDE_NO_CONTRACT':
      return { ...defaultState, isFetched: true };

    case 'OMAVIIHDE_RESET':
      return { ...defaultState };

    case 'OMAVIIHDE_ORDERS':
      return { orders: formatOrders(action.data) };
  }

  return state;
}

function formatOrders(data) {
  const input = {...defaultOrders, ...data};

  const stbs = [];
  const cards = [];

  for (let device of input.devices) {
    if (device.model && device.model.type) {
      if (device.model.type === 'kaapeliTv') {
        cards.push(device);
      } else {
        stbs.push(device);
      }
    }
  }

  const cardReaders = [];
  for (let cardID of input.cardLinks) {
    cardReaders.push({ id: cardID, model: { name: 'Kortinlukija' } });
  }

  let contract = { type: 'other'};
  if (input.viihdeAppSubscription.viihdeContract) {
    contract = input.viihdeAppSubscription.viihdeContract;
    contract.type = 'contract';
  }

  if (input.viihdeAppSubscription.viihdeApplication)
  {
    contract = input.viihdeAppSubscription.viihdeApplication;
    contract.type = 'application';
  }

  contract.earliestCloseDate = input.viihdeAppSubscription.earliestCloseDate || '';

  return {
    contract,
    stbs,
    cards,
    cardReaders
  };
}



// WEBPACK FOOTER //
// ./web/js/stores/reducers/omaviihde.js